<template>
  <div class="star">
    <span v-for="(itemClass, index) in itemClasses" :key="index" :class="itemClass"
          class="star-item"></span>
  </div>
</template>

<script>
  // 设置常量
  const LENGTH = 5
  const CLS_ON = 'on'
  const CLS_OFF = 'off'

  export default {
    data () {
      return {
        initial: this.score
      }
    },
    props: {
      score: {
        type: Number,
        default: 3.5
      }
    },
    computed: {
      itemClasses () {
        let result = []
        let score = (Math.floor(this.score)) / 2
        for (let i = 0; i < score; i++) {
          result.push(CLS_ON)
        }
        while (result.length < LENGTH) {
          result.push(CLS_OFF)
        }
        return result
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .star {
    display: block;
    height: 15px;
    float: left;
    overflow: hidden;

    .star-item {
      width: 15px;
      height: 15px;
      display: inline-block;
      font-size: 0;
      border: 0;
    }

    .on {
      background: url("star-on.png") no-repeat center center;
      background-size: 100% 100%;
    }

    .off {
      background: url("star-off.png") no-repeat center center;
      background-size: 100% 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CourseDetails/star/star.vue